// formConfig.js
const formConfig = {
    modify_collection_item: '修改收集项',
    add_collection_item: '新增收集项',
    id: 'id',
    registration_type: '注册类型',
    channel_id: '渠道id',
    forum_id: '论坛id',
    field_name: '字段名称',
    display_name: '显示名称',
    please_input_display_name: '请输入显示名称',
    field_type: '字段类型',
    warning_field_type_selection: '姓名手机号请选择系统自带的姓名手机号字段类型否则数据会统计失误！切记！！！！',
    upload_file_format: '上传文件格式',
    option_content: '选项内容',
    calendar_format: '日历格式',
    custom_format: '自定义格式',
    date_format_example: '格式	：yyyy-MM-dd HH:mm:ss',
    date_value_example: '示例值：2023-08-18 20:08:08',
    max_selection_limit: '最多可选几项',
    no_selection_limit: '此处为空或为0的时候不限制可选择数量。',
    min_resume_word_count: '个人简历最少字数',
    no_min_word_count_limit: '此处为空或为0的时候不限制！ 注意：英文网站按单词数量限制。',
    max_resume_word_count: '个人简历最大字数',
    user_selection_lock: '用户选择后不允许修改',
    field_required: '此项必填',
    parent_option_and_display_condition: '父级选项及显示条件',
    parent_option: '父级选项',
    parent_option_sort_notice: '注意：父级选项排序必须放子级字段前面',
    display_condition: '显示条件',
    display_condition_notice: '当父级选项，选择此条件后则会显示此项字段',
    hint_text: '提示文字',
    hint_when_value_empty: '值为空时提示',
    hint_when_verification_failed: '不能通过验证时的提示',
    notice_content: '须知内容',
    submit_immediately: '立即提交',
    notice_priority_system_fields: '注意：优先使用系统字段，否则会影响后期统计和导出数据有问题！',
    selected_form_items: '已选表单项',
    required: '必填',
    select_collection_items: '选择收集项',
    add_custom_collection_item: '添加自定义收集项',
    system_field: '系统',
    edit: '编辑',
    please_select: '请选择',
    please_enter: '请输入',
    please_upload: '请上传',
    yes: '是',
    no: '否',
    submit: '提交',
    mobile: '手机号',
    remark: '备注',
    save: '保存',
    parent_type: '父级分类',
    type_id: '分类ID',
    type_name: '分类名称',
    small_img: '缩略图',
    child_type_limit: '子类限制',
    child_type_limit_extra: '允许在该分类下的几个子类内选择门票，0为不限制，无子类别忽略该设置',
    ticket_limit: '门票限制',
    ticket_limit_extra: '允许在该类别下选择几种门票，1为单选，0为不限制（多选），其它数值为多选',
    please_enter_ticket_limit: '请输入可在该类别内选择',
    ticket_count_limit: '门票数量限制',
    ticket_count_limit_extra: '允许在该类别下选择多少张门票，1为单选，0为不限制（多选），其它数值为多选',
    sort: '排序',
    sort_extra: '值越大越靠前',
    status: '状态',
    description_text: '说明文字',
    only_upload_image: '您只能上传图像文件',
    please_upload_file: '请上传后缀为{type}的格式',
    is_open_inv_label: '是否开通发票信息收集',
    is_open_inv_checked: '开启',
    is_open_inv_unchecked: '关闭',
    inv_collect_deadline_label: '发票收集截止时间',
    inv_collect_deadline_extra: '注：发票收集截止时间如不填，默认不做限制！如果填写，前台发票收集会按照截止时间来处理',
    inv_type_label: '发票类型',
    inv_type_ordinary: '增值税普通发票',
    inv_type_special: '增值税专用发票',
    inv_type_electronic: '增值税普通电子发票',
    invoice_display_label: '是否必填发票信息',
    invoice_display_extra: '如果需要参会代表必填填写发票信息请选择“是”；如果允许代表选择不需要发票请选择“否”。',
    allowed_personal_label: '是否允许开个人发票',
    receipt_dow_label: '注册费收据下载',
    receipt_dow_checked: '开',
    receipt_dow_unchecked: '关',
    receipt_tpl_label: '注册费收据模板',
    receipt_tpl_extra: '建议文件小于3M，支持doc、docx格式',
    receipt_tpl_download: '英文收据模板下载',
    upload_file_text: '上传文件',
    view_file_text: '查看',
    receipt_tpl_required: '请上传注册费收据模板',
    addition_receipt_dow_label: '附加活动费收据下载',
    addition_receipt_tpl_label: '附加活动费收据模板',
    addition_receipt_tpl_download: '英文附加活动收据模板下载',
    addition_receipt_tpl_required: '请上传附加活动费收据模板',
    accompany_receipt_dow_label: '陪同费收据下载',
    accompany_receipt_tpl_label: '陪同费收据模板',
    accompany_receipt_tpl_download: '英文陪同收据模板下载',
    accompany_receipt_tpl_required: '请上传陪同费收据模板',
    save_button_text: '保存',
    config_label_notice: '配置域标签时，请阅读',
    config_label_doc: '《域标签配置使用说明文档》',
    label_info_title: '域标签信息',
    save_success: '保存成功',
    only_doc: '只能上传doc、docx格式的文件',
    file_size_limit: '文件大小不能超过3M',
    user_name: '用户名称',
    order_no: '订单编号',
    pay_way: '支付方式',
    pay_status: '支付状态',
    pay_finished: '已支付',
    pay_wait: '待支付',
    refund_status: '退款状态',
    refund_wait: '未退款',
    refund_finished: '退款完成',
    refund_fail: '拒绝退款',
    refund_ing: '退款中',
    refund_apply: '申请退款',
    audit_status: '审核状态',
    audit_wait: '待审核',
    audit_pass: '已通过',
    audit_fail: '未通过',
    no_audit: '不需要审核',
    money: '金额',
    to: '至',
    is_open_register: '是否开启门票预订',
    open: '开启',
    close: '关闭',
    template_selection: '模板选择',
    registration_deadline: '门票预订截止日期',
    registration_button_text: '个人中心菜单预订按钮文字',
    custom_registration_address: '自定义门票预订地址',
    is_open_group_purchase: '是否开启团组购票',
    show_ticket_holder_menu_default_yourself_as_ticket_holder_but_cannot_add_or_invite_only_one_ticket_per_purchase: '显示持票人菜单，默认自己为持票人，但是不能新增，不能邀请，每张门票只能买一张',
    ticket_holder_list_can_be_added_and_invited_select_or_supplement_ticket_holder_information_after_selecting_multiple_tickets_and_then_pay:
        '持票人列表可以新增和邀请，选择多张门票后选择或补充持票人信息后进行支付',
    open_for_others_to_purchase_tickets: '开启-为他人购票',
    close_only_allow_yourself_to_purchase_tickets: '关闭-仅可以自己购票',
    is_verify_ticket_holder_information: '是否校验持票人信息',
    do_not_verify_whether_the_mobile_phone_number_of_the_ticket_holder_is_duplicated: '不校验持票人手机号信息是否重复',
    verify_whether_the_mobile_phone_number_of_the_ticket_holder_is_duplicated_in_this_conference: '校验持票人手机号在本次会议中是否重复',
    no_do_not_verify_whether_the_mobile_phone_number_of_the_ticket_holder_is_duplicated: '否，不校验持票人手机号是否重复',
    yes_verify_whether_the_mobile_phone_number_of_the_ticket_holder_is_duplicated: '是，校验持票人手机号是否重复',
    can_pay_after_registration_deadline: '门票截止后是否可以支付',
    unpaid_orders_can_be_paid: '未支付订单可以支付',
    unpaid_orders_cannot_be_paid_anymore: '未支付订单不可再支付',
    audit_information_method: '审核资料方式',
    submit_one_audit_information_for_each_order_regardless_of_the_number_of_tickets_purchased: '每笔订单提交一份审核资料，无论购买多少张门票',
    each_ticket_holder_of_each_ticket_must_submit_one_audit_information: '每张门票的每个持票人都要提交一份审核资料',
    submit_information_by_order: '按订单资料提交',
    submit_information_by_ticket_holder: '按持票人提交资料',
    payment_audit_method: '支付审核方式',
    audit_first_then_pay: '先审核再支付',
    pay_first_then_audit: '先支付再审核',
    perfect_information_configuration: '完善信息配置',
    after_registering_an_account_and_logging_in_there_is_no_need_to_perfect_the_conference_registration_form_perfect_information_when_purchasing_tickets:
        '注册账号登录后，无需完善会议注册表单，购票时完善信息',
    after_registering_an_account_and_logging_in_you_must_perfect_the_conference_registration_form_before_you_can_continue_operating: '注册账号登录后，必须完善会议注册表单后才可以继续操作',
    need_to_perfect_information_after_logging_in: '登录后需要完善信息',
    need_to_perfect_information_when_purchasing_tickets: '购票时需要完善信息',
    personal_center_login_page_title: '个人中心登录页标题',
    personal_center_login_page_text_description: '个人中心登录页文字说明',
    please_enter_prompt_content: '请输入提示内容',
    upload_img: '上传图片',
    only_upload_doc_image: '只能上传doc、docx格式 和 图片',
    upload_doc_file: '请上传后缀为.docx类型的文档',
    please_enter_the_correct_id_card_number: '请输入正确的身份证号码',
    please_enter_the_correct_email: '请输入正确的邮箱',
    please_enter_the_correct_phone_number: '请输入正确的手机号',
    the_phone_number_already_exists: '该手机号码已经存在，请使用该手机号码直接登录或找回密码！',
    sms_verification: '短信验证',
    please_enter_the_verification_code: '请输入验证码',
    set_password: '设置密码',
    please_enter_password: '请输入密码',
    password_cannot_be_empty: '密码不能为空',
    password_must_be_a_combination_of_letters_lowercase_numbers_uppercase_special_characters_and_at_least_6_characters: '密码必须是字母小写、数字、字母大写、特殊字符中任意两种组合，且不能少于6位！',
    confirm_password: '确认密码',
    please_confirm_password: '请确认密码',
    the_id_card_number_format_is_incorrect: '身份证号格式不正确',
    signed_in: '已签到',
    not_signed_in: '未签到',
    you_two_input_passwords_are_not_the_same: '您两次输入的密码不一致！',
    the_id_card_number_is_incorrect: '身份证号不正确',
    the_account_format_is_incorrect: '账号格式不正确！',
    please_select_icon: '请选择图标',
    please_upload_file_type: '请上传{type}类型的文件',
    only_upload_audio_file: '您只能上传音频文件',
    add_options : '添加选项',
    is_audit_label: "注册信息是否需要审核",
    audit_remark: '审核说明文字',
    status_on: '开启',
    status_off: '关闭',
    audit_title: '表单审核配置',
    audit_tips: '用户完善注册表单或注册后等待审核，审核通过后才可以购票',
    user_register: '是否开启参会注册',
    user_register_tips: '登录页显示新用户注册按钮',
    is_use_meeting: '是否使用会议配置'
};

export default formConfig;
